import ViewedProductList from '@/components/ViewedProductList'
import type { Product } from '@/types'
import { getViewedProducts } from '@/utils/endpoint'
import { useEffect, useState } from 'react'

type ViewedProductListWrapperProps = {
  className?: string
}

const ViewedProductListWrapper = ({
  className,
}: ViewedProductListWrapperProps) => {
  const [viewedProducts, setViewedProducts] = useState<Product[]>([])

  useEffect(() => {
    getViewedProducts().then(data => setViewedProducts(data))
  }, [])

  if (!viewedProducts.length) {
    return null
  }

  return <ViewedProductList data={viewedProducts} className={className} />
}

export default ViewedProductListWrapper
